import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-areas:
    'status date'
    'creator date';
  grid-column-gap: 0.5rem;
`;
